<script setup lang="ts">

import { useIsAuthenticated } from 'vue3-msal-plugin';
import { useUserStore } from '@/stores/user';
import { currentVersion } from '@/releaseNotes';
const isAuthenticated = useIsAuthenticated()
const userStore = useUserStore();

</script>

<template>
  <div class="home-splash">
    <img src="https://image.foundimagepress.com/FBT-00010/medium" alt="Bikini Systems Speedo" />
    <h3 class="mt-1 mb-0">Bikini Systems Speedo</h3>
    
    <div class="d-flex justify-content-between">
    <div v-if="isAuthenticated">
      Welcome {{ userStore.user.name }}
    </div>
    <div v-else>
      Not signed in.
    </div>
    <div>Version {{ currentVersion }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home-splash {
  padding: 1rem;
  width: 600px;
  margin: 100px auto 0;
  background-color: #fff;
  border: 1px solid rgba(255, 20, 147, 0.25);

  img {
    max-width: 100%;
  }
}
</style>